import './App.css';
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {useParallaxEffect} from "./hooks/useParallaxEffect";
import {usePostMessage} from "./hooks/usePostMessage";
import Explore from './assets/Explore.jpg'
import EventOne from './assets/EventOne.png'
import ProfileOne from './assets/ProfileOne.png'
import EventTwo from './assets/EventTwo.png'
import Profile from './assets/Profile.png'
import SharedInterest from './assets/SharedInterest.png'
import MakePlan from './assets/MakePlan.png'
import TemplateCardOne from './assets/TemplateOne.png'
import TemplateCardTwo from './assets/TemplateTwo.png'
import TemplateCardThree from './assets/TemplateThree.png'
import ChatScreen from './assets/Chat.png'
import MessageOne from './assets/MessageOne.png'
import MessageOneReaction from './assets/MessageOneReaction.png'
import MessageTwo from './assets/MessageTwo.png'
import MessageThree from './assets/MessageThree.png'
import AppleDownload from './assets/AppleDownload.png';
import Qr from './assets/QR.png';
import PitchSocialLanding from './assets/PitchSocialLanding.png';
import {useParallaxController} from "react-scroll-parallax";

const MIN_WIDTH = 600;

const getBioType = matches => matches ? 'desktop' : 'mobile';

function App() {
    const appRef = useRef(null);
    const effectRef = useRef();
    const containerRef = useRef();
    const [bioType, setBioType] = useState(() => getBioType(window.innerWidth > MIN_WIDTH));
    const [finished, setFinished] = useState(false)
    const {postMessage} = usePostMessage();
    const parallaxController = useParallaxController();

    const {
      pitchSocialLanding,
      introTitle,
      introTitleWrapper,
      introFigure,
      introPage,
      exploreTitle,
      exploreCards,
      exploreDescription,
      explorePage,
      profileTitle,
      profileFigure,
      profileInterest,
      profileDescription,
      profilePage,
      makePlanTitle,
      makePlanFigure,
      makePlanCards,
      makePlanDescription,
      makePlanCardFadeOut1,
      makePlanCardFadeOut2,
      makePlanCardScaleOut,
      makePlanPage,
      chatFigure,
      chatMessageFigure,
      chatMessageHeart,
      chatMessageFigure2,
      chatMessageFigure3,
      chatPage,
      downloadPage,
      downloadPageTitle,
      downloadPageLink
    } = useParallaxEffect(bioType);

    useEffect(() => {
        const mql = window.matchMedia(`(min-width: ${MIN_WIDTH}px)`);
        const handler = e => setBioType(getBioType(e.matches));
        mql.addEventListener('change', handler);
        const messageHandler = ({data, origin}) => {
          if (data?.onSnap) {
            /** @type HTMLDivElement */
            const container = containerRef.current;
            /** @type HTMLDivElement */
            const effectContainer = effectRef.current;
            container.classList.remove('hidden');
            effectContainer.classList.add('visible');
          }
        }
        window.addEventListener('message', messageHandler);
        return () => {
            mql.removeEventListener('change', handler);
            window.removeEventListener('message', messageHandler);
        };
    }, []);

    useLayoutEffect(() => {
      const current = appRef.current;
      parallaxController.updateScrollContainer(current);
    }, [parallaxController]);

    const freezeParallax = () => {
      /** @type {HTMLDivElement} */
      const containerElement = containerRef.current;
      const pages = appRef.current.getElementsByClassName('page');
      for (const page of Array.from(pages)) {
        if (page.classList.contains('download')) {
          continue;
        }
        page.style.display = 'none';
      }
      containerElement.style.display = 'none';
    }

    const handleScrolling = (event) => {
      /** @type {HTMLDivElement} */
      const target = event.nativeEvent.target;
      const remainScrolling = target.scrollHeight - (target.clientHeight + target.scrollTop);
      const atScrollEnd = remainScrolling <= 100;
      if (atScrollEnd && !finished) {
        setFinished(true)
        postMessage({resume: true});
        freezeParallax()
      }
    }

    return (
      <div onClick={() => window.open('https://apps.apple.com/us/app/pitch-social/id1508774657', '_parent')} className={bioType !== 'mobile' ? 'App' : 'App mobile'} ref={appRef} onScroll={handleScrolling}>
        {!finished && <a href="https://apps.apple.com/us/app/pitch-social/id1508774657" target="_PARENT" ref={pitchSocialLanding.ref} className="intro-landing">
            <img src={PitchSocialLanding} alt={"pitch-social-landing"}/>
        </a>}
        <div ref={effectRef} className={'how-pitch-works'}>
          {/* Introduction page */}
          <div ref={introPage.ref} className="page intro">
            <div ref={introTitle.ref} className="intro-title">
              {/*<span>How Pitch Works</span>*/}
            </div>
            <div ref={introTitleWrapper.ref} className="intro-figure">
              <div ref={introFigure.ref} className="intro-figure">
                <img src={Explore} alt="event-card"/>
              </div>
            </div>
          </div>
          <div ref={explorePage.ref} className="page explore">
            <div ref={exploreTitle.ref} className="explore-title">
              <span>Discover Plans</span>
            </div>
            <div ref={exploreCards.ref} className="explore-cards">
              <div className="explore-card event">
                <img src={EventOne} alt="Pitch's event card figure"/>
              </div>
              <div className="explore-card profile">
                <img src={ProfileOne} alt="Pitch's profile card figure"/>
              </div>
              <div className="explore-card event">
                <img src={EventTwo} alt="Pitch's event card figure"/>
              </div>
            </div>
            <div ref={exploreDescription.ref} className={bioType === 'mobile' ? 'explore-description-mobile' : 'explore-description'}>
              <span>
                Effortless Exploration: Easily find exciting activities without the guesswork
              </span>
            </div>
          </div>
          <div ref={profilePage.ref} className="page profile">
            <div ref={profileTitle.ref} className="profile-title">
              <span>Find Your People</span>
            </div>
            <div ref={profileFigure.ref} className="profile-figure">
              <img src={Profile} alt="Pitch's Profile"/>
            </div>
            <div ref={profileInterest.ref} className="profile-interest">
              <img src={SharedInterest} alt="Pitch's user shared interest"/>
            </div>
            <div ref={profileDescription.ref} className={bioType === 'mobile' ? "profile-description-mobile" : "profile-description"}>
              <span>
                Discover shared interests; pick one to create your plan
              </span>
            </div>
          </div>
          <div ref={makePlanPage.ref} className="page make-plan">
            <div ref={makePlanTitle.ref} className="make-plan-title">
              <span>Make Real Plans</span>
            </div>
            <div ref={makePlanFigure.ref} className="make-plan-figure">
              <img src={MakePlan} alt="Make Real Plan with Pitch"/>
            </div>
            <div ref={makePlanCards.ref} className="make-plan-cards">
              <div ref={makePlanCardFadeOut1.ref} className="template-card">
                <img src={TemplateCardOne} alt="Pitch's event template"/>
              </div>
              <div ref={makePlanCardScaleOut.ref} className="template-card">
                <img src={TemplateCardTwo} alt="Pitch's event template"/>
              </div>
              <div ref={makePlanCardFadeOut2.ref} className="template-card">
                <img src={TemplateCardThree} alt="Pitch's event template"/>
              </div>
            </div>
            <div ref={makePlanDescription.ref} className={bioType === 'mobile' ? "make-plan-description-mobile" : "make-plan-description"}>
              <span>Get Social: Enjoy real life experiences with new friends</span>
            </div>
          </div>
          <div ref={chatPage.ref} className="page chat">
            <div ref={chatFigure.ref} className="chat-figure">
              <img src={ChatScreen} className="figure-image" alt="Chat with your people"/>
              <div ref={chatMessageFigure.ref} className="chat-message-figure">
                <img src={MessageOne} className="chat-message-box" alt="Pitch's message example 1"/>
                <img ref={chatMessageHeart.ref} src={MessageOneReaction} className="chat-message-heart" alt="Pitch's message like"/>
              </div>
              <div ref={chatMessageFigure2.ref} className="chat-message-figure">
                <img className="chat-message-box-2" src={MessageTwo} alt="Pitch's message example 2"/>
              </div>
              <div ref={chatMessageFigure3.ref} className="chat-message-figure">
                <img className="chat-message-box-3" src={MessageThree} alt="Pitch's message example 3"/>
              </div>
            </div>
          </div>
          <div ref={downloadPage.ref} className="page download">
            <div ref={downloadPageTitle.ref} className="download-title">
              <h3>Available now</h3>
            </div>
            <div ref={downloadPageLink.ref} className="download-link">
              <a href="https://apps.apple.com/us/app/pitch-social/id1508774657" target="_PARENT">
                {bioType === 'mobile' ? <img src={AppleDownload} alt="Download Pich Social"/> : <img src={Qr} alt="Download Pich Social"/>}
              </a>
            </div>
          </div>
        </div>
        <div ref={containerRef} className="container hidden">
        </div>
      </div>
    );
}

export default App;
